import {
  ALLTICKETS_RECEIVE_FAIL,
  ALLTICKETS_RECEIVE_REQUEST,
  ALLTICKETS_RECEIVE_SUCCESS,
  TICKET_CREATE_FAIL,
  TICKET_CREATE_REQUEST,
  TICKET_CREATE_SUCCESS,
  TICKET_ASSIGN_FAIL,
  TICKET_ASSIGN_REQUEST,
  TICKET_ASSIGN_SUCCESS,
  SINGLETICKET_RECEIVE_FAIL,
  SINGLETICKET_RECEIVE_REQUEST,
  SINGLETICKET_RECEIVE_SUCCESS,
  MESSAGE_SEND_REQUEST,
  MESSAGE_SEND_FAIL,
  MESSAGE_SEND_SUCCESS,
  MERCHANTTICKETS_RECEIVE_REQUEST,
  MERCHANTTICKETS_RECEIVE_SUCCESS,
  MERCHANTTICKETS_RECEIVE_FAIL,
  TICKET_CLOSE_FAIL,
  TICKET_CLOSE_SUCCESS,
  TICKET_CLOSE_REQUEST,
} from "./ticketType";

export const ticketReducer = (state = {}, action) => {
  switch (action.type) {
    case ALLTICKETS_RECEIVE_REQUEST || TICKET_CREATE_REQUEST:
      return { ...state, loading: true };

    case ALLTICKETS_RECEIVE_SUCCESS:
      return { ...state, loading: false, tickets: action.payload };

    case TICKET_CREATE_SUCCESS :
      return{...state,loading:false,newticket:action.payload}
      
    case ALLTICKETS_RECEIVE_FAIL || TICKET_CREATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case SINGLETICKET_RECEIVE_REQUEST:
      return { ...state, loading: true };

    case SINGLETICKET_RECEIVE_SUCCESS:
      return { ...state, loading: false, ticket: action.payload };

    case SINGLETICKET_RECEIVE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case MESSAGE_SEND_REQUEST:
      return { ...state, loading: true };

    case MESSAGE_SEND_SUCCESS:
      return { ...state, loading: false, message: action.payload };

    case MESSAGE_SEND_FAIL:
      return { ...state, loading: false, error: action.payload };

    case TICKET_ASSIGN_REQUEST:
      return { ...state, loading: true };

    case TICKET_ASSIGN_SUCCESS:
      return { ...state, loading: false, assigned: action.payload };

    case TICKET_ASSIGN_FAIL:
      return { ...state, loading: false, error: action.payload };
    
      case TICKET_CLOSE_REQUEST:
      return { ...state, loading: true };

    case TICKET_CLOSE_SUCCESS:
      return { ...state, loading: false, close: action.payload };

    case TICKET_CLOSE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case MERCHANTTICKETS_RECEIVE_REQUEST:
      return { ...state, loading: true };

    case MERCHANTTICKETS_RECEIVE_SUCCESS:
      return { ...state, loading: false, merchant: action.payload };

    case MERCHANTTICKETS_RECEIVE_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
